(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nuralea-shoppable-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuralea-video-stories')) {
    customElements.define('nuralea-video-stories', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('.nl-stories__content');
        this.items = [...this.querySelectorAll('[data-story-item]')];
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.visiblePreviews = new Set();
        this.index = 0;
        this.dialog.lang = this.lang;
        document.body.appendChild(this.dialog);
        const handleClick = event => {
          const trigger = event.target.closest('[data-story-open]');
          if (trigger && typeof this.dialog.showModal === 'function') {
            event.preventDefault();
            this.returnTarget = trigger;
            this.open(this.items.indexOf(trigger.closest('[data-story-item]')));
          }
          if (event.target.closest('[data-story-close]')) this.close();
          if (event.target.closest('[data-story-next]')) this.show(this.index + 1);
          if (event.target.closest('[data-story-prev]')) this.show(this.index - 1);
          if (event.target.closest('[data-story-play]') && this.video) {
            if (this.video.paused || this.video.error) this.playActive();
            else this.video.pause();
          }
          if (event.target.closest('[data-story-mute]') && this.video) this.video.muted = !this.video.muted;
          if (event.target.closest('[data-story-scroll]')) {
            const rail = this.querySelector('.nl-stories__rail');
            const end = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 3;
            rail.scrollTo({ left: end ? 0 : rail.scrollLeft + rail.clientWidth * .75, behavior: this.motion.matches ? 'instant' : 'smooth' });
          }
        };
        this.addEventListener('click', handleClick, { signal });
        this.dialog.addEventListener('click', handleClick, { signal });
        this.dialog.addEventListener('click', event => {
          if (event.target === this.dialog) {
            const box = this.dialog.getBoundingClientRect();
            if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
          }
        }, { signal });
        this.dialog.addEventListener('keydown', event => {
          if (event.target.closest('video, input, select, textarea, .nl-stories__products')) return;
          if (event.key === 'ArrowRight') { event.preventDefault(); this.show(this.index + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index - 1); }
        }, { signal });
        this.dialog.addEventListener('focusin', event => {
          const card = event.target.closest('.nl-stories__product');
          if (card) card.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        }, { signal });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.finish(); }, { signal });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, { signal });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !event.defaultPrevented && this.viewerOpen && this.desktop.matches && !document.querySelector('dialog:modal')) {
            event.preventDefault();
            this.close();
          }
        }, { signal });
        this.desktop.addEventListener('change', () => { if (this.viewerOpen) this.present(); }, { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video?.pause();
          this.updatePreviews();
        }, { signal });
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.video?.pause();
          this.updatePreviews();
        }, { signal });
        document.addEventListener('nuralea:story-open', event => {
          if (event.detail !== this && this.dialog.open) this.close();
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const selected = this.items.find(item => item.dataset.storyId === event.detail?.blockId);
          if (selected) selected.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => entry.isIntersecting ? this.visiblePreviews.add(entry.target) : this.visiblePreviews.delete(entry.target));
          this.updatePreviews();
        }, { threshold: .5 });
        this.querySelectorAll('[data-story-preview]').forEach(video => {
          video.muted = true;
          video.addEventListener('playing', () => video.setAttribute('data-playing', ''), { signal });
          video.addEventListener('volumechange', () => { if (!video.muted) video.muted = true; }, { signal });
          video.addEventListener('error', () => video.removeAttribute('data-playing'), { signal });
          this.observer.observe(video);
        });
        this.dialog.querySelector('[data-story-prev]').disabled = this.items.length < 2;
        this.dialog.querySelector('[data-story-next]').disabled = this.items.length < 2;
        this.resizeObserver = new ResizeObserver(() => {
          const rail = this.querySelector('.nl-stories__rail');
          this.querySelector('[data-story-scroll]').hidden = rail.scrollWidth <= rail.clientWidth + 3;
        });
        this.resizeObserver.observe(this.querySelector('.nl-stories__rail'));
      }
      updatePreviews() {
        const allowed = this.dataset.previewAutoplay === 'true' && !this.motion.matches && !document.hidden && !document.querySelector('.nl-stories__dialog[open]');
        this.querySelectorAll('[data-story-preview]').forEach(video => {
          if (allowed && this.visiblePreviews.has(video)) {
            if (!video.getAttribute('src')) video.src = video.dataset.src;
            video.play().catch(() => {});
          } else video.pause();
        });
      }
      open(index) {
        document.dispatchEvent(new CustomEvent('nuralea:story-open', { detail: this }));
        if (!this.viewerOpen) {
          this.viewerOpen = true;
          this.present();
        }
        document.querySelectorAll('nuralea-video-stories').forEach(stories => stories.updatePreviews());
        this.show(index);
      }
      present() {
        const focused = this.dialog.contains(document.activeElement) ? document.activeElement : null;
        if (this.dialog.open) this.dialog.close();
        this.unlockScroll();
        this.dialog.dataset.mode = this.desktop.matches ? 'dock' : 'modal';
        this.dialog.setAttribute('aria-modal', this.desktop.matches ? 'false' : 'true');
        if (this.desktop.matches) {
          this.dialog.show();
        } else {
          this.dialog.showModal();
          this.scrollLock = document.documentElement.style.overflow;
          document.documentElement.style.overflow = 'hidden';
        }
        focused?.focus({ preventScroll: true });
      }
      unlockScroll() {
        if (this.scrollLock !== undefined) {
          document.documentElement.style.overflow = this.scrollLock;
          this.scrollLock = undefined;
        }
      }
      releaseVideo() {
        this.videoAbort?.abort();
        if (!this.video) return;
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        this.video.load();
        this.video = null;
      }
      setLoading(loading) {
        this.dialog.querySelector('.nl-stories__loading').hidden = !loading;
        this.content.setAttribute('aria-busy', loading ? 'true' : 'false');
      }
      show(index) {
        if (!this.items.length) return;
        this.releaseVideo();
        this.index = (index + this.items.length) % this.items.length;
        const item = this.items[this.index];
        this.content.replaceChildren(item.querySelector('template').content.cloneNode(true));
        this.video = this.content.querySelector('video');
        this.dialog.querySelector('.nl-stories__counter').textContent = (this.index + 1) + ' / ' + this.items.length;
        this.dialog.querySelector('.nl-stories__error').hidden = true;
        this.dialog.querySelector('[data-story-fallback]').href = item.dataset.storyMp4 || item.querySelector('[data-story-open]').href;
        this.setLoading(false);
        if (this.video) {
          const video = this.video;
          this.videoAbort = new AbortController();
          const options = { signal: this.videoAbort.signal };
          video.controls = false;
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.preload = 'auto';
          video.loop = true;
          const sources = [...video.querySelectorAll('source')];
          const hls = sources.find(source => /mpegurl/i.test(source.type) || /\.m3u8(?:\?|$)/i.test(source.src));
          const mp4 = item.dataset.storyMp4 || sources.find(source => source.type === 'video/mp4')?.src;
          const adaptive = hls && (video.canPlayType('application/vnd.apple.mpegurl') || video.canPlayType('application/x-mpegURL'));
          this.fallbackSource = adaptive ? mp4 : null;
          const source = adaptive ? hls.src : mp4;
          if (source) video.src = source;
          ['play', 'pause', 'volumechange', 'loadedmetadata'].forEach(event => video.addEventListener(event, () => this.updateControls(), options));
          video.addEventListener('playing', () => { this.setLoading(false); this.dialog.querySelector('.nl-stories__error').hidden = true; this.updateControls(); }, options);
          video.addEventListener('waiting', () => this.setLoading(true), options);
          video.addEventListener('error', () => {
            if (this.fallbackSource) {
              video.src = this.fallbackSource;
              this.fallbackSource = null;
              video.load();
              this.playActive();
            } else {
              this.setLoading(false);
              this.dialog.querySelector('.nl-stories__error').hidden = false;
              video.controls = true;
              this.updateControls();
            }
          }, options);
          video.load();
          if (this.dialog.open) this.playActive();
        }
        this.updateControls();
      }
      playActive() {
        const video = this.video;
        if (!video || !this.viewerOpen || document.hidden) return;
        if (video.error) video.load();
        this.setLoading(video.readyState < 3);
        this.dialog.querySelector('.nl-stories__error').hidden = true;
        const playback = video.play();
        playback?.catch(error => {
          if (this.video !== video || !this.viewerOpen || error.name === 'AbortError') return;
          this.setLoading(false);
          video.controls = true;
          this.updateControls();
          const tap = this.content.querySelector('.nl-stories__tap');
          if (tap) tap.hidden = false;
        });
      }
      updateControls() {
        const paused = !this.video || this.video.paused;
        const muted = !this.video || this.video.muted;
        this.dialog.querySelectorAll('[data-story-play]').forEach(button => button.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel));
        const tap = this.content.querySelector('.nl-stories__tap');
        if (tap) tap.hidden = !paused && !this.video?.error;
        this.dialog.querySelector('[data-story-mute]').setAttribute('aria-label', muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
        this.dialog.querySelector('[data-play-icon]').toggleAttribute('hidden', !paused);
        this.dialog.querySelector('[data-pause-icon]').toggleAttribute('hidden', paused);
        this.dialog.querySelector('[data-muted-icon]').toggleAttribute('hidden', !muted);
        this.dialog.querySelector('[data-sound-icon]').toggleAttribute('hidden', muted);
      }
      close() {
        const focused = document.activeElement;
        const restoreFocus = this.dialog.contains(focused) || this.dialog.dataset.mode === 'modal';
        if (this.dialog.open) this.dialog.close();
        this.finish(restoreFocus);
        if (!restoreFocus && focused?.isConnected) focused.focus({ preventScroll: true });
      }
      finish(restoreFocus = false) {
        if (!this.viewerOpen) return;
        this.viewerOpen = false;
        this.releaseVideo();
        this.content.replaceChildren();
        this.setLoading(false);
        this.unlockScroll();
        if (restoreFocus) this.returnTarget?.focus({ preventScroll: true });
        document.querySelectorAll('nuralea-video-stories').forEach(stories => stories.updatePreviews());
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
        this.close();
        this.appendChild(this.dialog);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
